export const useDummyFlowDigests = false;

export const flowDigests = [
    {
        id: 1,
        date: "2023-11-23",
        amount: 7900.36,
        tax_amount: 12,
        orders: 8,
        // transaction: null,
        transaction: {
            id: 1033,
            number: "IV-FLOW-0001",
        },
        flow_location: {
            id: 1,
            name: 'Bukit Bintang',
        },
        created_at: "2023-12-01 12:00:00",
        updated_at: "2023-12-02 14:30:00",
    },
    {
        id: 2,
        date: "2023-11-24",
        amount: 300,
        tax_amount: 8,
        orders: 2,
        transaction: null,
        flow_location: {
            id: 1,
            name: 'Bukit Bintang',
        },
        created_at: "2023-12-01 12:00:00",
        updated_at: "2023-12-02 14:30:00",
    },
    {
        id: 3,
        date: "2023-11-25",
        amount: 200,
        tax_amount: 6.5,
        orders: 2,
        transaction: null,
        flow_location: {
            id: 2,
            name: 'KLCC',
        },
        created_at: "2023-12-01 12:00:00",
        updated_at: "2023-12-02 14:30:00",
    },
];

export const flowDigestsPagination = {
    total: 3,
    current_page: 1,
    per_page: 10,
};
